import React, {useContext, useEffect, useState} from 'react'
import Select from "react-select";
import PermissionContext from '../../../context/permissions/permissionsContext'

const AddRoles = ({allPermissions, handleCancle}) => {
    const permissionContext = useContext(PermissionContext);

    const { 
        addNewRole, 
        permissionLoading, 
    } = permissionContext;
    
    const [user_permission, setPermission] = useState()
    const [selectPermission, setSelectPermission] = useState([""])
    const [name, setRoleName] = useState("")

    useEffect(() => {
        formNewArrayFromUserPermissionContext()
        
      }, []);
    
    
        const formNewArrayFromUserPermissionContext = () =>{
          const arr = [];
          allPermissions.map((role)=>{
            return arr.push({value: role.name, label: role.name});
          })
          setSelectPermission(arr);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const permission = [];

        const guard_name = "web"


        user_permission.map((en) => {
          return permission.push(en.value);
        });

        // console.log({
        //     name,
        //     permission
        // });
    
    
        const response = addNewRole({
            name,
            permission,
            guard_name
        });
      };
  return (
    <>
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-6xl">
          <form  
            onSubmit={handleSubmit} 
            className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-center justify-center p-5 border-b border-solid border-slate-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                Add New Role1
              </h3>
            </div>
            <div className="relative p-6 flex-auto">
              <div className="my-4 text-slate-500 text-lg leading-relaxed h-80 w-[50rem] overflow-y-auto">
              <div>
                <div className="mt-6">
                        <label htmlFor="email" className="flex ml-[5rem]">
                            Role Name <p className='text-red-500'> * </p> 
                        </label>
                        <div className="flex justify-center items-center mt-1">
                        <input
                            type="text"
                            name="Role"
                            onChange={(e) => setRoleName(e.target.value)}
                            className="border-gray-300 border rounded w-4/5 h-10 mx-2"
                            placeholder='Role Name'
                        />
                    </div>
                </div>
                <div className="flex flex-col w-full my-2">
                    <label htmlFor="role" className="flex mx-2 ml-[5rem] my-1 text-lg">
                        Permissions <p className='text-red-500'> * </p> 
                    </label>
                    <div className="flex flex-col w-full items-center justify-center">
                    <Select
                        isMulti
                        options={selectPermission}
                        placeholder="Select User Permissions"
                        value={user_permission}
                        onChange={(user_permission) => setPermission(user_permission)}
                        className="basic-multi-select w-4/5 "
                        classNamePrefix="select"
                    />
                    
                    </div>
                </div>
                <div className="flex items-center justify-between mx-16 p-6 ">
                </div>
                {/* <div className='border-t border-solid border-slate-200 rounded-b mb-12 mx-12'>

                </div> */}
            </div>
              </div>
            </div>
            <div className="flex items-center justify-between p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                    className="bg-[#ffc000] active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 mx-8"
                    type="button"
                    onClick={handleCancle}
                >
                Cancel
                </button>
              <button
                className="bg-emerald-500 mr-8  text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={handleSubmit}
                >
                Add Role
                </button>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>  
    )
}

export default AddRoles